var chunkToChildrenMap = {
	"2768": [
		9656,
		8843,
		4048
	]
};
__webpack_require__.f.prefetch = function(chunkId, promises) { Promise.all(promises).then(function() {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}); };